<template>
  <div>
    <DropdownConfiguration :controller="FitTypeExtrapolateCtller" />
    <p
      v-if="RangeToExtrapolateTextCtrller.value!=='' || RangeFromExtrapolateTextCtrller.value!==''"
      class="range-display expanded-info pt-2"
    >
      <span v-if="RangeFromExtrapolateTextCtrller.value!==''">{{ RangeFromExtrapolateTextCtrller.value }}&#60;</span>
      <span> t </span>
      <span v-if="RangeToExtrapolateTextCtrller.value!==''">&#60;{{ RangeToExtrapolateTextCtrller.value }}</span>
    </p>
    <p
      v-else
      class="range-display expanded-info pt-2"
    >
      Study timeline
    </p>
    <TextInputConfiguration
      :controller="RangeFromExtrapolateTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      class="expanded-info m-0"
    />
    <TextInputConfiguration
      :controller="RangeToExtrapolateTextCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
      class="mb-2 expanded-info m-0"
    />
  </div>
</template>

<script>
import DropdownConfiguration from '@/components/properties/elements/DropdownConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import {inputTextConfCtrller,comboBoxConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'

const rootContextFolder='ReportViewer/Studies/Extrapolate/'

export default {
  name: 'Extrapolate',
  components:{
    TextInputConfiguration,
    DropdownConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data() {
    return {
      ExtrapolateExpanded:true,
      elementsConfig:[],
      FitTypeExtrapolateCtller: new comboBoxConfCtrller(ConfigName.Extrapolate_Type,
        [
          {text:'Linear',value:'Linear'},
          {text:'Quadratic',value:'Quadratic'},
          {text:'Inverse square root',value:'Inverse square root'},
          {text:'Semilog x',value:'Semilog x'},
          {text:'Semilog y',value:'Semilog y'},
          {text:'Double log',value:'Double log'},
          {text:'Exponential x',value:'Exponential x'},
          {text:'Exponential y',value:'Exponential y'},
          {text:'Michaelis-Menten',value:'Michaelis-Menten'},
        ],'Extrapolate',0,rootContextFolder+'FitType'),
			RangeFromExtrapolateTextCtrller: new inputTextConfCtrller(ConfigName.ExtrapolateFromPreProc,'From','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
      RangeToExtrapolateTextCtrller: new inputTextConfCtrller(ConfigName.ExtrapolateToPreProc,'To','Please give a numerical value or leave it empty to consider all the graph','',(value)=>{return !isNaN(value) ||value===''}),
    }
  },
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  created(){
    this.elementsConfig = [
      this.FitTypeExtrapolateCtller,
      this.RangeFromExtrapolateTextCtrller,
      this.RangeToExtrapolateTextCtrller,
    ]
  },
  mounted(){
    this.configureStudy()
  },
  methods:{
    configureStudy(){
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this))
    }
  }
}
</script>

<style>
.range-display{
  font-weight: bold;
  text-align: center;
  font-size: 0.85rem;
}
</style>